import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild , ElementRef } from '@angular/core';
import { VideoRecordingService } from '../video-recording.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-sample1',
  templateUrl: './sample1.component.html',
  styleUrls: ['./sample1.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class Sample1Component implements  OnInit {

  @ViewChild('videoElement',{static: true}) videoElement: ElementRef;
  video: any;
  isPlaying = false;
  displayControls = true;
  isAudioRecording = false;
  isVideoRecording = false;
  audioRecordedTime;
  videoRecordedTime;
  audioBlobUrl;
  videoBlobUrl;
  audioBlob;
  videoBlob;
  audioName;
  videoName;
  dataurl : any;
  audioStream;
  videoStream: MediaStream;
  audioConf = { audio: true}
  videoConf = { video: { facingMode:"user", width: 400 , height : 200}, audio: {echoCancellation:true}}

  constructor(
    private ref: ChangeDetectorRef,
    private videoRecordingService: VideoRecordingService,
    private sanitizer: DomSanitizer
  ) {

    this.videoRecordingService.recordingFailed().subscribe(() => {
      this.isVideoRecording = false;
      this.ref.detectChanges();
    });

    this.videoRecordingService.getRecordedTime().subscribe((time) => {
      this.videoRecordedTime = time;
      this.ref.detectChanges();
    });

    this.videoRecordingService.getStream().subscribe((stream) => {
      this.videoStream = stream;
      this.ref.detectChanges();
    });

    this.videoRecordingService.getRecordedBlob().subscribe((data) => {
      this.videoBlob = data.blob;
      this.videoName = data.title;
      this.videoBlobUrl = this.sanitizer.bypassSecurityTrustUrl(data.url);
      console.log(data.url);
      
      blobToBase64(data.blob).then(res => {
        // console.log(res);
        this.dataurl = res;  
        let b64 = this.dataurl.replace(/^data:.+;base64,/, '');
        localStorage.setItem("videoblob", b64);
        console.log(localStorage.getItem('videoblob'));

       });
      this.ref.detectChanges();
    });
  }

  ngOnInit() {
    this.video = this.videoElement.nativeElement;
    console.log(this.video);
    
  }

  startVideoRecording() {
    if (!this.isVideoRecording) {
      this.video.controls = false;
      this.isVideoRecording = true;
      this.videoRecordingService.startRecording(this.videoConf)
      .then(stream => {
        // this.video.src = window.URL.createObjectURL(stream);
        this.video.srcObject = stream;
        this.video.play();
        this.video.volume = 0;
        this.video.muted = 0;
      })
      .catch(function (err) {
        console.log(err.name + ": " + err.message);
      });
    }
  }

 

  stopVideoRecording() {
    if (this.isVideoRecording) {
      this.videoRecordingService.stopRecording(1);
      this.video.volume = 1;
      this.video.muted = 1;
      this.video.srcObject = this.videoBlobUrl;
      this.isVideoRecording = false;
      this.video.controls = true;
      
    }
  }

  clearVideoRecordedData() {
    this.videoBlobUrl = null;
    this.video.srcObject = null;
    this.video.controls = false;
    this.ref.detectChanges();
  }
  
}

const blobToBase64 = blob => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise(resolve => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};
